import React from "react";
import { Container } from "semantic-ui-react";

const Leihboote = () => {
  return (
    <Container id="Filme" className="main_content">
      <h1>Filme und Videos</h1>
      <div className="videoWrapper">
        <iframe
          src="https://www.youtube.com/embed/w7fx9iLPrpc"
          allowFullScreen
        />
      </div>
    </Container>
  );
};

export default Leihboote;



// WEBPACK FOOTER //
// ./src/components/Filme/index.js